import type { TypeFilterSection } from '@/types/list/types.list.filter';

const SHOWN = 2;

export function filterSummary(section: TypeFilterSection, selected: readonly string[], excluded = false): string {
    if (!selected.length) return '';
    const labels = selected.map((value) => section.options.find((option) => option.value === value)?.label ?? value);
    const head = labels.slice(0, SHOWN).join(', ');
    const rest = labels.length > SHOWN ? ` +${labels.length - SHOWN}` : '';
    return `${excluded ? 'non ' : ''}${head}${rest}`;
}

export default filterSummary;
